import * as actions from './actionTypes';
import { setLoading, setMessage } from './general';
import axios from '../../config/axiosInstance';

export const fetchTimeClocksSuccess = timeClocks => ({
  type: actions.FETCH_TIMECLOCKS_SUCCESS,
  timeClocks,
});

export const fetchTimeClocks = params => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .post('/timeclock/remake/period', params)
    .then((response) => {
      dispatch(setLoading(false));
      dispatch(fetchTimeClocksSuccess(response.data[0].itens));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const createTimeClock = data => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post('/timeclock/remake/', data)
    .then(() => {
      dispatch(setLoading(false));
      dispatch(setMessage('Ponto cadastrado com sucesso.'));
      return Promise.resolve();
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const deleteTimeClockSuccess = (remake, data) => ({
  type: actions.DELETE_TIMECLOCK_SUCCESS,
  remake,
  data,
});

export const deleteTimeClock = data => (dispatch) => {
  dispatch(setLoading(true));
  const { remake, ...params } = data;
  return axios({
    method: remake ? 'delete' : 'post',
    url: `/timeclock/remake/${remake ? data.timeclockId : ''}`,
    data: { ...params },
  })
    .then((response) => {
      dispatch(deleteTimeClockSuccess(remake, response.data));
      dispatch(setLoading(false));
      dispatch(setMessage(remake
        ? response.data.category ? 'Ponto desfeito' : 'Ponto reconsiderado'
        : 'Ponto desconsiderado.'));
      return Promise.resolve();
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const updateSelectedStartDateSuccess = selectedStartDate => ({
  type: actions.UPDATE_SELECTED_START_DATE_SUCCESS,
  selectedStartDate,
});

export const updateSelectedStartDate = selectedStartDate => (dispatch) => {
  dispatch(updateSelectedStartDateSuccess(selectedStartDate));
};

export const updateSelectedEndDateSuccess = selectedEndDate => ({
  type: actions.UPDATE_SELECTED_END_DATE_SUCCESS,
  selectedEndDate,
});

export const updateSelectedEndDate = selectedEndDate => (dispatch) => {
  dispatch(updateSelectedEndDateSuccess(selectedEndDate));
};
